import { useIntl } from 'react-intl';
import SegmentedControl from '@alltrails/denali/components/SegmentedControl';
import { LayerType } from '../../types/LayerMenu';
import styles from './LayerMenu.module.scss';

type Props = {
  layerType: LayerType;
  options: Array<{ id: LayerType; label: string }>;
  onLayerTypeChange: (newLayerType: LayerType) => void;
};

const LayerControl = ({ layerType, options, onLayerTypeChange }: Props) => {
  const intl = useIntl();
  if (options.length <= 1) {
    return null;
  }

  return (
    <SegmentedControl
      className={styles.segmentedControl}
      ariaLabel={intl.formatMessage({ defaultMessage: 'Layer type' })}
      activeId={layerType}
      options={options}
      onChange={onLayerTypeChange}
    />
  );
};

export default LayerControl;
